import React from 'react'
import { Outlet } from 'react-router-dom'

const SplashLayout = () => {
  return (
    <div>
      <Outlet />
    </div>
  )
}

export default SplashLayout
